/**
 * @packageDocumentation
 * @module HackerAPI
 */
import HackerAPIFetch from "./hackerapi-fetch/hackerapi-fetch";
import Organization from "./organization/organization";
import Address from "./address/address";
import Claim from "./claim/claim";
import Company from "./company/company";
import Error from "./error/error";
import Event from "./event/event";
import File from "./file/file";
import Institution from "./institution/institution";
import Email from "./email/email";
import Notification from "./notification/notification";
import Pipeline from "./pipeline/pipeline";
import Search from "./search/search";
import Skill from "./skill/skill";
import User from "./user/user";
import * as Utils from "./utils/utils";
import Auth from "./auth/auth";
var HackerAPI = /** @class */ (function () {
    function HackerAPI() {
    }
    Object.defineProperty(HackerAPI, "Address", {
        /**
         * @type { HackerAPI.Address }
         */
        get: function () {
            return Address;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Auth", {
        /**
         * @type { HackerAPI.Auth }
         */
        get: function () {
            return Auth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Claim", {
        /**
         * @type { HackerAPI.Claim }
         */
        get: function () {
            return Claim;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Company", {
        /**
         * @type { HackerAPI.Company }
         */
        get: function () {
            return Company;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Email", {
        /**
         * @type { HackerAPI.Email }
         */
        get: function () {
            return Email;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Error", {
        /**
         * @type { HackerAPI.Error }
         */
        get: function () {
            return Error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Event", {
        /**
         * @type { HackerAPI.Event }
         */
        get: function () {
            return Event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "File", {
        /**
         * @type { HackerAPI.File }
         */
        get: function () {
            return File;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "HackerAPIFetch", {
        /**
         * @type { HackerAPI.HackerAPIFetch }
         */
        get: function () {
            return HackerAPIFetch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Institution", {
        /**
         * @type { HackerAPI.Institution }
         */
        get: function () {
            return Institution;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Notification", {
        /**
         * @type { HackerAPI.Notification }
         */
        get: function () {
            return Notification;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Organization", {
        /**
         * @type { HackerAPI.Organization }
         */
        get: function () {
            return Organization;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Pipeline", {
        /**
         * @type { HackerAPI.Pipeline }
         */
        get: function () {
            return Pipeline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Search", {
        /**
         * @type { HackerAPI.Search }
         */
        get: function () {
            return Search;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Skill", {
        /**
         * @type { HackerAPI.Skill }
         */
        get: function () {
            return Skill;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "User", {
        /**
         * @type { HackerAPI.User }
         */
        get: function () {
            return User;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HackerAPI, "Utils", {
        /**
         * @type { HackerAPI.Utils }
         */
        get: function () {
            return Utils;
        },
        enumerable: true,
        configurable: true
    });
    return HackerAPI;
}());
export default HackerAPI;
//# sourceMappingURL=HackerAPI.js.map